import { request } from "../network/request";
const db = "dn0";


/**
 * 导出下载模板
 */
 export function hyyhsDownload(params) {

    return request({
      url: "pmp/jxcp/hyyhsDownload",
      method: "post",
      params,
    });
  }

  export function hyyhsLogList(params) {
    return request({
      url: "pmp/jxcp/hyyhsLogList",
      method: "post",
      params: {
        ...params,
      },
    });
  }

  /**
 *  活跃用户数导入
 * @param {*} data 
 * @returns 
 */
export function hyyhsUpload(data) {
  return request({
      url: "pmp/jxcp/hyyhsUpload",
      method: "post",
      data
  });
}

//数据入库
export function importHyyhs() {
  return request({
      url: "pmp/jxcp/importHyyhs",
      method: "get",
      params:{},
  });
}

//  功能点击率

/**
 * 导出下载模板
 */
 export function gndjlDownload(params) {

  return request({
    url: "pmp/jxcp/gndjlDownload",
    method: "post",
    params,
  });
}

export function gndjlLogList(params) {
  return request({
    url: "pmp/jxcp/gndjlLogList",
    method: "post",
    params: {
      ...params,
    },
  });
}

/**
*  活跃用户数导入
* @param {*} data 
* @returns 
*/
export function gndjlUpload(data) {
return request({
    url: "pmp/jxcp/gndjlUpload",
    method: "post",
    data
});
}

//数据入库
export function importGndjl() {
return request({
    url: "pmp/jxcp/importGndjl",
    method: "get",
    params:{},
});
}

//功能点击率明细列表
export function djlList(query) {
  return request({
      url: "pmp/jxcpmx/djlList",
      method: "post",
      params:
          query

  });
}

//功能点击率明细列表导出
export function djlExport(query) {
  return request({
      url: "pmp/jxcpmx/djlExport",
      method: "post",
      params:
          query
  });
}

// 获取行员类型
export function fetchHylx() {
  return request({
    url: '/system/getDictData',
    method: 'get',
    params: {
      dictType: "hylx",
      type: "2"
    },
  })
}

//活跃用户数明细列表
export function yhsList(params) {
  return request({
    url: "pmp/jxcpmx/yhsList",
    method: "post",
    params: {
      ...params,
    },
  });
}

export function yhsExport(params) {

  return request({
    url: "pmp/jxcpmx/yhsExport",
    method: "post",
    params,
  });
}


